// extracted by mini-css-extract-plugin
module.exports = {"globalNav":"globalNav_globalNav__1rp7i","globalNavLink":"globalNav_globalNavLink__mulcV","globalNavDropdownTrigger":"globalNav_globalNavDropdownTrigger__YyLHE"};